// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"481":"83a88b15","635":"55dbe896","779":"c9a85edd","826":"81f28977","832":"c9a85edd"}[chunkId] + ".css";
};